import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!url || !publishableKey) {
  throw new Error(
    "Missing Supabase config. Set VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY in apps/assessment/.env"
  );
}

// Untyped client — repositories provide the type discipline at the call site.
// Once you run `pnpm --filter assessment gen:types` against a real schema,
// you can switch this back to `createClient<Database>(...)` and remove the
// type assertions in the repositories.
export const supabase: SupabaseClient = createClient(url, publishableKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export type AppSupabaseClient = SupabaseClient;
